import React, { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider }  from "react-bootstrap-table2-paginator";
import * as actions from "../../../../../_redux/teacher-courses/TeacherCoursesAction";
import * as uiHelpers from "../SectionsAndCoursesUIHelpers";
import { 
  getSelectRow, 
  getHandlerTableChange,  
  NoRecordsFoundMessage, 
  PleaseWaitMessage, 
  sortCaret
} from "../../../../../../../../_metronic/_helpers";
import { Pagination } from "../../../../../../../../_metronic/_partials/controls";
import { useSectionsAndCoursesUIContext } from "../SectionsAndCoursesUIContext";

export function SectionsAndCoursesTable() {
  // Sections And Courses UI Context
  const sectionsAndCoursesUIContext = useSectionsAndCoursesUIContext();
  const sectionsAndCoursesUIProps = useMemo(() => {
    return {
      ids: sectionsAndCoursesUIContext.ids,
      setIds: sectionsAndCoursesUIContext.setIds,
      queryParams: sectionsAndCoursesUIContext.queryParams,
      setQueryParams: sectionsAndCoursesUIContext.setQueryParams
    };
  }, [sectionsAndCoursesUIContext]);

  // Getting curret state of Sections And Courses list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.teacherCourses }),
    shallowEqual
  );
  const { totalCount, sectionAndCourseIds, entities, listLoading } = currentState;

  // Sections And Courses Redux state
  const dispatch = useDispatch();
  
  useEffect(() => {
    sectionsAndCoursesUIProps.setIds(sectionAndCourseIds);
    dispatch(actions.getSectionsAndCourses(sectionsAndCoursesUIProps.queryParams));
    return () => dispatch(actions.cleanTeacherCoursesState());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sectionAndCourseIds, sectionsAndCoursesUIProps.queryParams, dispatch]);

  // Table columns
  const columns = [
    {
      dataField: "gradeLevelName",
      text: "Sınıf Düzeyi",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "section",
      text: "Sınıf",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "course",
      text: "Ders",
      sort: true,
      sortCaret: sortCaret
    }
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: sectionsAndCoursesUIProps.queryParams.pageSize,
    page: sectionsAndCoursesUIProps.queryParams.pageNumber
  };
  
  return (
    <PaginationProvider pagination={paginationFactory(paginationOptions)}>
      {({ paginationProps, paginationTableProps }) => {
        return (
          <Pagination
            isLoading={listLoading}
            paginationProps={paginationProps}
          >
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              remote
              keyField="id"
              data={entities ? entities : [] }
              columns={columns}
              defaultSorted={uiHelpers.defaultSorted}
              onTableChange={getHandlerTableChange(
                sectionsAndCoursesUIProps.setQueryParams
              )}
              selectRow={getSelectRow({
                entities,
                ids: sectionsAndCoursesUIProps.ids,
                setIds: sectionsAndCoursesUIProps.setIds,
              })}
              {...paginationTableProps}
            >
              <PleaseWaitMessage entities={entities} />
              <NoRecordsFoundMessage entities={entities} />
            </BootstrapTable>
          </Pagination>
        );    
      }}
    </PaginationProvider>  
  );
}